/* eslint-disable  */
import { Button, Card, Col, Row } from "reactstrap";
import DataGrid from "../../components/dataGrid/DataGrid";
import moment from "moment";
import { useEffect, useReducer, useState } from "react";
import QueryString from "qs";
import { useLocation, useNavigate } from "react-router-dom";
import {
  exportExcelDispatchSummary,
  getDispatchSummaries,
} from "../../services/dispatchSummary.service";
import toast from "react-hot-toast";
import FormInput from "../../components/FormInput";
import FormSelect from "../../components/FormSelect";
import { getParties } from "../../services/parties.service";

const columns = [
  {
    selector: (row: any) => row.serialNumber,
    name: "S.No.",
    sortable: false,
    //   wrap: true,
    maxWidth: "70px",
    minWidth: "70px",
  },

  {
    selector: (row: any) => row.party?.code || "N/A",
    name: "Code",
    sortable: false,
    wrap: true,
  },
  {
    selector: (row: any) => row.party?.name || "N/A",
    name: "Party name",
    sortable: false,
    wrap: true,
  },

  {
    selector: (row: any) => row.orderNumber,
    name: "Order Number",
    sortable: false,
    wrap: true,
  },
  {
    selector: (row: any) => moment(row.orderDate).format("DD-MM-YYYY"),
    name: "Order Date",
    sortable: false,
    wrap: true,
  },
  {
    selector: (row: any) => row.orderAmount,
    name: "Order Amount",
    sortable: false,
    wrap: true,
  },

  {
    selector: (row: any) => row.invoiceNumber,
    name: "Invoice Number",
    sortable: false,
    wrap: true,
  },

  {
    selector: (row: any) => moment(row.invoiceDate).format("DD-MM-YYYY"),
    name: "Invoice Date",
    sortable: false,
    wrap: true,
  },

  {
    selector: (row: any) => row.invoiceAmount,
    name: "Invoice Amount",
    sortable: false,
    wrap: true,
  },

  {
    selector: (row: any) => row.numberOfBox,
    name: "Number of Box",
    sortable: false,
    wrap: true,
  },

  {
    selector: (row: any) => moment(row.dispatch?.dispatchDate).format("DD-MM-YYYY"),
    name: " Dispatch Date",
    sortable: false,
    wrap: true,
  },

  {
    selector: (row: any) => row.dispatch.driverName,
    name: "Driver Name",
    sortable: false,
    wrap: true,
  },

  {
    selector: (row: any) => row.dispatch.vehicleNumber,
    name: "Vehicle Number",
    sortable: false,
    wrap: true,
  },
];

const initialState = {
  data: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  totalResults: 0,
  startIndex: 1,
  endIndex: 10,
};

function reducer(state: any, action: any) {
  switch (action.type) {
    case "SET_DATA":
      return action.payload;
    default:
      return state;
  }
}

export default function DispatchSummary() {
  const [filterData, setFilterData] = useState({
    orderNumber: "",
    invoiceNumber: "",
    orderFrom: "",
    orderTo: "",
  });
  const [party, setParty] = useState("");
  const [data, dispatch] = useReducer(reducer, initialState);
  const location = useLocation();
  const navigate = useNavigate();
  const query = QueryString.parse(location.search, { ignoreQueryPrefix: true });

  const setData = (data: any) => {
    dispatch({ type: "SET_DATA", payload: data });
  };
  useEffect(() => {
    const { page, orderNumber, invoiceNumber, orderFrom, orderTo, party } = query;
    getDispatchSummaries({ page, orderNumber, invoiceNumber, orderFrom, orderTo, party })
      .then((response: any) => {
        setData(response.data);
      })
      .catch(() => {});
  }, [location.search]);

  const handleFilter = () => {
    const queryParams: any = { ...query, page: 1, ...filterData };
    Object.keys(queryParams).forEach((key) => {
      if (!queryParams[key]) {
        delete queryParams[key];
      }
    });
    const queryString = QueryString.stringify(queryParams);
    navigate(`${location.pathname}${Object.keys(queryParams).length > 0 ? "?" + queryString : ""}`);
  };

  const handleClearFilter = () => {
    setFilterData({ orderNumber: "", invoiceNumber: "", orderFrom: "", orderTo: "" });
    const queryParams = { page: 1 };
    const queryString = QueryString.stringify(queryParams);
    navigate(`${location.pathname}?${queryString}`);
  };

  return (
    <div className='d-flex flex-column h-100 px-sm-1 w-100 pb-sm-1'>
      <Row className='align-items-center mb-2'>
        <Col sm>
          <h1 className='my-1 fw-bold h4'>Dispatch Summary</h1>
        </Col>
      </Row>

      <div className='flex-grow-1 overflow-auto'>
        <Card className='h-100 p-3 w-100 '>
          <div className='d-flex flex-column h-100 rounded-0'>
            <DataGrid
              columns={columns}
              data={data}
              filterByDate={true}
              FilterSubHeader={true}
              subHeaderComponent={
                <Row>
                  <Col md={2}>
                    <FormSelect
                      id='party'
                      name='party'
                      label='Party'
                      isAsync
                      isClearable
                      defaultFilter={{ status: true }}
                      getOptions={getParties}
                      onChange={(name: any, value: any) => {
                        setParty(value);
                        setFilterData({
                          ...filterData,
                          [name]: value?.id,
                        });
                      }}
                      getOptionLabel={(row: any) => (
                        <>
                          <small>{row.name}</small>
                          <div>({row.code})</div>
                        </>
                      )}
                      value={party}
                    />
                  </Col>
                  <Col md={2}>
                    <FormInput
                      name='orderNumber'
                      label='Order Number'
                      placeholder='Order Number'
                      onChange={(e) =>
                        setFilterData({
                          ...filterData,
                          [e.target.name]: e.target.value,
                        })
                      }
                      value={filterData.orderNumber}
                    />
                  </Col>
                  <Col md={2}>
                    <FormInput
                      name='invoiceNumber'
                      label='Invoice Number'
                      placeholder='Invoice Number'
                      onChange={(e) =>
                        setFilterData({
                          ...filterData,
                          [e.target.name]: e.target.value,
                        })
                      }
                      value={filterData.invoiceNumber}
                    />
                  </Col>
                  <Col md={2}>
                    <FormInput
                      name='orderFrom'
                      label='From Date'
                      placeholder='From Date'
                      type='date'
                      onChange={(e) =>
                        setFilterData({
                          ...filterData,
                          [e.target.name]: e.target.value,
                        })
                      }
                      value={filterData.orderFrom}
                    />
                  </Col>
                  <Col md={2}>
                    <FormInput
                      name='orderTo'
                      label='To Date'
                      placeholder='To Date'
                      type='date'
                      onChange={(e) =>
                        setFilterData({
                          ...filterData,
                          [e.target.name]: e.target.value,
                        })
                      }
                      value={filterData.orderTo}
                    />
                  </Col>

                  <Col md={2} className='mt-1'>
                    <div className='mt-4'>
                      <Button
                        color='primary'
                        size='sm'
                        className='me-2'
                        onClick={() => handleFilter()}
                      >
                        Filter
                      </Button>
                      <Button
                        color='danger'
                        size='sm'
                        className='me-2'
                        onClick={() => handleClearFilter()}
                      >
                        Clear
                      </Button>
                      <Button
                        color='primary'
                        size='sm'
                        onClick={() => {
                          const { orderNumber, invoiceNumber, orderFrom, orderTo, party } = query;
                          exportExcelDispatchSummary({
                            orderNumber,
                            invoiceNumber,
                            orderFrom,
                            orderTo,
                            party,
                          })
                            .then((response) => {
                              const blobURL = URL.createObjectURL(response.data);
                              const anchor = document.createElement("a");
                              anchor.href = blobURL;
                              anchor.download = "Dispatch Summary.xlsx";
                              anchor.click();
                              URL.revokeObjectURL(blobURL);
                            })
                            .catch(() => {
                              toast.error("Record not found to export.");
                            });
                        }}
                      >
                        Export
                      </Button>
                    </div>
                  </Col>
                </Row>
              }
            />
          </div>
        </Card>
      </div>
    </div>
  );
}
